module.exports = __webpack_public_path__ + "static/media/handshake-alt.c8c97d06.svg";